module.exports = __webpack_public_path__ + "img/img111.1cbb55c6.png";